import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from './core/user.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IsLoggedGuard  {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.userService.user$.pipe(
      catchError(err => of(false)),
      map(user => {
        if (!!!user) {
          this.router.navigate(['/login']);
          return false;
        }

        return true;
      }),
    );
  }
}
